import "./style.css";
import logo from "../../assets/images/dim_logo_blanco.svg";
import { Button, Icon, Image } from "semantic-ui-react";
import { useContext } from "react";
import logout from "../../context/actions/auth/logout";
import { GlobalContext } from "../../context/Provider";
import { useHistory } from "react-router";

const Header = () => {
  const history = useHistory();

  const {
    authState: {
      auth: { data },
    },
    authDispatch,
    pendienteDispatch,
    historicoDispatch,
  } = useContext(GlobalContext);

  const handleLogout = () => {
    logout(history)(authDispatch, pendienteDispatch, historicoDispatch);
  };

  return (
    <div className="Header Navbar">
      <div className="leftSide">
        <Image src={logo} width={120} />
      </div>
      <div className="centerSide">
        <p>Portal recibos pendientes pacientes</p>
      </div>
      <div className="rightSide" style={{ display: "flex" }}>
        {data && <p>{data.usuario.nombre + " " + data.usuario.apellido}</p>}
        <Button onClick={handleLogout} inverted color="vk" icon>
          <Icon name="log out"></Icon>
          Salir
        </Button>
      </div>
    </div>
  );
};

export default Header;
